/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Trash2 } from 'lucide-react';
import ConfirmDialog from '../../../components/ConfirmDialog';

function EmailDeleteModal({
  closeModal,
  email,
  onDelete,
}) {
  return (
    <ConfirmDialog
      tone="danger"
      icon={<Trash2 size={24} />}
      title="Delete this email?"
      description={`You're about to delete the "${email}" email. This action cannot be undone.`}
      confirmLabel="Delete"
      cancelLabel="Cancel"
      onConfirm={() => { onDelete(); closeModal(); }}
      onCancel={closeModal}
    />
  );
}

EmailDeleteModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default EmailDeleteModal;
